import { Alert, Button, Input, Modal, Popconfirm, Row } from 'antd';
import * as React from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { useRef, useState } from 'react';

export function ApprovalHierarchyEditTitle({
	title,
	visible,
	width,

	onNext,
	onCancel,
	setApprovalHierarchyName,
	approvalHierarchy,
}) {
	const [showAlert, setShowAlert] = useState(false);
	const titleRef = useRef();
	const validate = () => {
		if (nullSafeGet('name', approvalHierarchy)) {
			setShowAlert(false);
			onNext();
		} else {
			setShowAlert(true);
		}
	};
	return (
		<Modal
			visible={visible}
			width={width}
			title={title}
			destroyOnClose={true}
			bodyStyle={{ overflow: 'hidden', padding: '12px 24px' }}
			footer={
				<Row>
					<div style={{ marginLeft: 'auto' }}>
						<Popconfirm
							onConfirm={onCancel}
							placement="topLeft"
							title="Are you sure you want to cancel?"
							okText="Yes"
							cancelText="No"
						>
							<Button>Cancel</Button>
						</Popconfirm>
						<Button type={'primary'} style={{ marginLeft: '8px' }} onClick={validate}>
							Next
						</Button>
					</div>
				</Row>
			}
			closable={false}
			maskClosable={false}
		>
			{showAlert ? (
				<Alert
					style={{ marginBottom: 8 }}
					message={'Please give your approval hierarchy a title.'}
					type="error"
				/>
			) : null}
			<span>Approval Hierarchy Title</span>
			<Input
				ref={titleRef}
				defaultValue={nullSafeGet('name', approvalHierarchy)}
				onChange={(e) => setApprovalHierarchyName(e.target.value)}
			/>
		</Modal>
	);
}
